import React, { useCallback, useMemo } from "react";
import * as S from "./SoftwareTabs.styles";
import { ProgressAnimationButton } from "components/ProgressAnimationButton";
import { useTranslation } from "hooks/useTranslation";
import { ISlide } from "../../FullStackNetworkingSoftware.types";

export const SoftwareTabs = ({
  slides,
  activeTab,
  videoPlaybackTime,
  isInView,
  onUpdateTab,
}: Readonly<{
  slides: Array<ISlide>;
  activeTab: ISlide;
  videoPlaybackTime: Record<string | number, number>;
  isInView?: boolean;
  onUpdateTab?: (tab: ISlide) => void;
}>) => {
  const { t } = useTranslation();

  const playbackTime = useMemo(() => {
    return videoPlaybackTime[activeTab.id];
  }, [activeTab.id, videoPlaybackTime]);

  const isActive = useCallback(
    (tab: ISlide) => {
      return isInView && tab.id === activeTab.id && !!playbackTime;
    },
    [isInView, activeTab.id, playbackTime],
  );

  return (
    <S.StyledScrollWrapper
      direction="horizontal"
      align="center"
      scrollStepType="itemWidth"
      alignActive="center"
      hideArrows
      enableWheelScroll
      gap={12}
      activeIndex={activeTab?.index}
      items={slides.map((item, index) => ({
        id: String(item.id),
        key: item.id,
        render: () => (
          <S.ButtonWrapper>
            <ProgressAnimationButton
              isActive={activeTab?.id === item.id}
              canPlayAnimation={isActive(item)}
              variant="secondary"
              text={t(item.label)}
              playbackTimeInSeconds={
                videoPlaybackTime[index] || item.playbackTimeInSeconds
              }
              handleClick={() => onUpdateTab(item)}
            />
          </S.ButtonWrapper>
        ),
      }))}
    />
  );
};
